import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGraphqlComponent } from './simple-icons-graphql.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGraphqlComponent ],
    exports:      [ SimpleIconsGraphqlComponent ],
    bootstrap:    []
})
export class SimpleIconsGraphqlModule {}
